import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './NewCircleModalCategories.scss';
import './NewCircleModalResults.scss';

import SmartImage from '../../../General/SmartImage';

const NewCircleModalCategories = props => {
  const { brandsToConsider, selectedBrands, setSelectedBrands } = props;

  const isBrandSelected = brand => selectedBrands.some(b => b.id === brand.id);
  const toggleBrand = brand =>
    setSelectedBrands(isBrandSelected(brand) ? props.selectedBrands.filter(b => b.id !== brand.id) : [...props.selectedBrands, brand]);
  const numCurrentSelected = props.selectedBrands.length;

  return (
    <div className='new-circle-modal-categories-container new-circle-modal-results-container'>
      <div className='new-circle-modal-body-title-container'>
        <div className='title'>Which brands match your taste?</div>
        <div className='subtitle'>Choose a few you love — we'll use them to recommend curators who actually use and share those brands.</div>
      </div>
      <div className='results'>
        {brandsToConsider.length
          ? brandsToConsider.map(brand => {
              const toggle = () => toggleBrand(brand);

              const isSelected = isBrandSelected(brand);
              const isAnotherSelected = !isSelected && !!numCurrentSelected;
              const additionalClasses = { selected: isSelected, 'another-selected': isAnotherSelected, loading: props.isLoadingBrands };
              return (
                <div className={cn('result', additionalClasses)} key={`${brand.id}`} onClick={toggle}>
                  <div className={cn('logo-container', additionalClasses)}>
                    {brand.logo ? (
                      <SmartImage src={brand.logo} alt={brand.name} fallbackText={brand.name} />
                    ) : (
                      <div className='fallback'>{brand.name}</div>
                    )}
                  </div>
                </div>
              );
            })
          : _.range(25).map(idx => (
              <div className='result loading' key={`${idx}`}>
                <div className='logo-container' />
              </div>
            ))}
      </div>
    </div>
  );
};

NewCircleModalCategories.propTypes = {
  shop: PropTypes.object.isRequired,
  brandsToConsider: PropTypes.array.isRequired,
  selectedBrands: PropTypes.array.isRequired,
  setSelectedBrands: PropTypes.func.isRequired,
  isLoadingBrands: PropTypes.bool.isRequired
};

export default NewCircleModalCategories;
